import { render, staticRenderFns } from "./ProjectCase.vue?vue&type=template&id=96b6b946&scoped=true"
import script from "./ProjectCase.vue?vue&type=script&lang=js"
export * from "./ProjectCase.vue?vue&type=script&lang=js"
import style0 from "./ProjectCase.vue?vue&type=style&index=0&id=96b6b946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b6b946",
  null
  
)

export default component.exports